import * as GoodsActionTypes from '../actions/goods';
import initialState from './initialState';


export default (state=initialState.goods, action) => {

    const { id, goodsList, goodItem, type } = action;

    switch(type){

        case GoodsActionTypes.LIST_GOODS:
            return { ...state }

        case GoodsActionTypes.LOAD_GOODS:
            return { ...state, goods: goodsList }
        
        case GoodsActionTypes.ADD_GOOD:
            return {
                ...state,
                goods: [...state.goods, goodItem]
            }
        
        case GoodsActionTypes.REMOVE_GOOD:
            return {
                ...state,
                goods: state.goods.filter(good => good.section_id !== id)
            }
        

        default:
            return state;
    }
}





// WEBPACK FOOTER //
// ./src/reducers/goods.js